"use strict";
// TODO: 型と変数名が同じだが問題が無いか？
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAnalyticsAnalyzingState = void 0;
exports.AdAnalyticsAnalyzingState = ['not_analyze', 'processing', 'processed'];
